// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"OverviewFAQSection_cardContainer__PPZX9","cardBox":"OverviewFAQSection_cardBox__R2oG6"};